<template>
	<div>
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<div class="button">
			<el-button type="primary" size="small" @click="showDialogEvn">添加新版本</el-button>
		</div>
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:table-style="{ name: 'mixture' }"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>

		<dialog-form
			:dialogVisible="showDoalog"
			@close:dialogVisible="val => (showDoalog = val)"
			:attributes="attributes"
			:formData="formData"
			@confirm="confirm"
		></dialog-form>
		<dialog-form
			:dialogVisible="richTextDialog"
			@close:dialogVisible="val => (richTextDialog = val)"
			:attributes="richTextParam"
			:showBtn="false"
		>
			<div slot="main">
				<div v-html="richText"></div>
				<div class="apkFileUrl" v-if="apkFileUrl">安卓版本包地址:{{ apkFileUrl }}</div>
			</div>
		</dialog-form>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import dialogForm from '@/components/dialogForm/dialogForm';
import { validRequired, validMax } from '@/common/elementValid.js';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import versions from '@/backend/services/account/setmeal.js';

const list = listPageCreate({
	searchConfig: {
		api: api.setmeal.versionList,
		method: 'POST',
	},
});
export default {
	mixins: [list],
	data() {
		return {
			richText: '11111111111',
			richTextDialog: false,
			showDoalog: false,
			richTextParam: {
				title: '版本新增内容',
			},
			attributes: {
				width: '50%',
				title: '添加新版本',
			},
			formData: {
				versionNum: {
					formType: 'sky-input',
					value: '',
					placeholder: '请输入版本号',
					label: '版本号',
					options: [],
					rules: [validRequired('请输入版本号', 'blur'), validMax(10)],
				},
				typeList: {
					formType: 'sky-checkbox',
					label: '适用系统',
					options: [
						{
							label: 'IOS',
							value: 'IOS',
						},
						{
							label: 'Android',
							value: 'Android',
						},
					],
					value: [],
					rules: [validRequired('请选择使用系统', 'blur')],
				},
				apkFile: {
					label: '安卓包上传',
					formType: 'sky-uploadImg',
					value: [],
					limit: 1,
					judgeType: 'app',
					platform: 'iglobalwin-pub-oss', //项目-空间-平台）
					folder: 'android', // 文件夹名称
					displayWith(formData) {
						return formData.typeList.value.indexOf('Android') != -1;
					},
				},
				isForcedUpdates: {
					label: '是否强更',
					formType: 'sky-switch',
					'active-text': '是',
					'inactive-text': '否',
					'active-value': 1,
					'inactive-value': 0,
					value: '',
				},
				env: {
					label: '环境开关',
					formType: 'sky-switch',
					'active-text': '是',
					'inactive-text': '否',
					'active-value': 1,
					'inactive-value': 0,
					value: '',
				},
				versionContent: {
					label: '版本内容',
					formType: 'sky-richtext',
					value: '',
					placeholder: '请输入版本内容',
					rules: [validRequired('请输入版本内容', 'blur')],
				},
				detailInfo: {
					label: '摘要',
					formType: 'sky-textarea',
					autosize: {
						minRows: 2,
						maxRows: 6,
					},
					value: '',
					placeholder: '请输入内容',
				},
			},
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '版本号',
						label: '版本号',
						prop: 'versionNum',
						value: '',
					},
					{
						label: '创建时间',
						startPlaceholder: '创建开始日期',
						endPlaceholder: '创建结束日期',
						prop: ['startDate', 'endDate'],
						tagName: 'sky-date-picker',
						type: 'daterange',
						value: [],
					},
				],
				multiples: [
					{
						defaultText: '系统',
						placeholder: '系统',
						label: '系统',
						prop: 'type',
						options: [
							{
								label: 'IOS',
								value: 'IOS',
							},
							{
								label: 'Android',
								value: 'Android',
							},
						],
						value: '',
					},
				],
			},
			column: [],
			apkFileUrl: '',
		};
	},
	mounted() {
		this.setColumn();
		this.query();
	},
	methods: {
		showDialogEvn() {
			this.showDoalog = true;
		},
		// 保存
		confirm(callback) {
			simpleFormPageCreate(
				{
					api: api.setmeal.addNewVersion,
					type: 'Post',
					data: this.formData,
				},
				res => {
					Object.keys(res).forEach(item => {
						if (item == 'apkFile') {
							res[item] = res.apkFile[0];
						}
						if (res[item] == '') {
							delete res[item];
						}
					});
					return res;
				}
			)
				.submit()
				.then(() => {
					this.query();
					callback && callback();
					this.$message.success('添加成功');
				})
				.catch(() => {
					callback && callback();
				});
		},
		setColumn() {
			let that = this;
			this.column = [
				{
					label: '版本号',
					bind: 'versionNum',
				},
				{
					label: '系统',
					bind: 'type',
				},
				{
					label: '是否强更',
					bind: 'isForcedUpdates',
					type: 'percentage',
					dataStyle(val) {
						return val ? '是' : '否';
					},
				},
				{
					label: '创建时间',
					bind: 'createTime',
				},
				{
					label: '安卓版本包',
					bind: 'apkFile',
					type: 'previewUploadFile',
				},
				{
					label: '版本状态',
					bind: 'auditProgress',
					type: 'listSwitch',
					'active-text': '已发布',
					'inactive-text': '审核中',
					'active-value': 1,
					'inactive-value': 0,
					disabled(scope) {
						let val = scope.row.auditProgress;
						if (val == 1) {
							return true;
						}
						return false;
					},
					change(val, scope, tableData, reset) {
						that
							.$confirm('是否确认发布？', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
							})
							.then(async () => {
								let res = await versions.versionsAudit({
									id: scope.row.id,
								});
								if (res.status == 204) {
									await that.promiseAsync();
									tableData.disabled(scope);
									that.$message.success('已发布');
								}
							})
							.catch(async () => {
								reset(0);
								that.$message({
									message: '已取消',
									type: 'warning',
									duration: 1500,
								});
							});
					},
				},
				{
					label: '版本内容',
					type: 'iconbutton',
					align: 'center',
					iconlist: [
						{
							name: 'chakanxiangqing',
							message: '查看详情',
							style: {
								color: '#5CAFFF',
							},
							callback(row) {
								that.richText = row.versionContent;
								that.apkFileUrl = row.apkFile ? row.apkFile.url : '';
								that.richTextDialog = true;
							},
						},
					],
				},
			];
		},
		promiseAsync() {
			return new Promise(reslove => {
				this.query();
				reslove();
			});
		},
	},
	components: { filterPanel, dialogForm },
};
</script>

<style lang="scss" scoped>
.button {
	width: 100%;
	height: 60px;
	margin: 10px 0;
	padding: 0 20px;
	background-color: #fff;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.apkFileUrl {
	margin: 20px 0;
}
</style>
